import React, { useMemo } from "react";
import { withMonogramContext } from "./MonogramContext";
import MonogramSwatches from "./MonogramSwatches";
import MonogramSettingHeader from "./MonogramSettingHeader";

function MonogramVariantSelector({
  chosenVariant,
  products,
  setChosenVariant,
  language,
  setUserActions,
  userActions,
}) {
  const standardVariants = useMemo(
    () =>
      products
        .filter((product) =>
          product.tags.some((t) => t.includes("customizer_swatch_category_Classic"))
        )
        .flatMap((product) => product.variants),
    [products]
  );

  // Check nonLimitedEditions and group them by their second option
  const groupedVariants = useMemo(() => {
    const groupedVariants = {};
    standardVariants.forEach((variant) => {
      const secondOption = variant.options[1] || "Classic";
      if (!groupedVariants[secondOption]) {
        groupedVariants[secondOption] = [];
      }
      groupedVariants[secondOption].push(variant);
    });
    return groupedVariants;
  }, [standardVariants]);

  const limitedEditionVariants = useMemo(
    () =>
      products
        .filter(
          (product) => !product.tags.some((t) => t.includes("customizer_swatch_category_Classic"))
        )
        .flatMap((product) => product.variants),
    [products]
  );
  const chosenVariantIsLimitedEdition = useMemo(
    () => limitedEditionVariants.some((variant) => variant.id === chosenVariant.id),
    [limitedEditionVariants, chosenVariant]
  );
  const availableLimitedEditionVariants = useMemo(() =>
    limitedEditionVariants.filter((v) => v.available)
  );

  const handleVariantSelect = (variant) => {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set("variant", variant.id);
    window.history.replaceState({}, "", `${window.location.pathname}?${urlParams}`);

    setChosenVariant(variant);
    setUserActions((prev) => ({ ...prev, hasSelectedVariant: true }));
  };

  return (
    <>
      {Object.entries(groupedVariants).map(([key, value], i) => {
        return (
          <div key={i}>
            <MonogramSettingHeader
              title={i === 0 && language.product_color}
              subtitlePrefix={key}
              subtitle={
                !chosenVariantIsLimitedEdition &&
                userActions.hasSelectedVariant &&
                (key === chosenVariant.option2 || !chosenVariant.option2)
                  ? chosenVariant.title.split(" / ")[0]
                  : ""
              }
            />
            <MonogramSwatches
              swatches={value
                .filter((variant) => variant.available)
                .map((variant) => ({
                  imageSrc: variant.swatch_image?.[0]?.src,
                  cldSrc: variant.swatch_image?.[0]?.cloudinary_src,
                  selected: chosenVariant.id === variant.id,
                  alt: variant.title,
                  value: variant,
                }))}
              selectSwatch={handleVariantSelect}
              shouldSelect={userActions.hasSelectedVariant}
              stretchImages
            />
          </div>
        );
      })}

      {availableLimitedEditionVariants.length > 0 && (
        <>
          <MonogramSettingHeader
            subtitlePrefix={language.limited_edition_product_color_subtitle}
            subtitle={
              chosenVariantIsLimitedEdition && userActions.hasSelectedVariant
                ? chosenVariant.title
                : ""
            }
          />

          <MonogramSwatches
            swatches={availableLimitedEditionVariants.map((variant) => ({
              imageSrc: variant.swatch_image?.[0]?.src,
              selected: chosenVariant.id === variant.id,
              cldSrc: variant.swatch_image?.[0]?.cloudinary_src,
              alt: variant.title,
              value: variant,
            }))}
            selectSwatch={handleVariantSelect}
            shouldSelect={userActions.hasSelectedVariant}
            stretchImages
          />
        </>
      )}
    </>
  );
}

export default withMonogramContext(MonogramVariantSelector);
